import { HttpClient } from "@angular/common/http";
import { APP_INITIALIZER, Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { HandShakeConfig } from "../utils/handshake.config";

@Injectable()
export class ConfigService {
    private config: any;
    constructor(private http: HttpClient) { }

    load() {
        return new Promise(resolve => {
            let url = "./assets/config/" + environment.appConfig;
            this.http.get(url)
                .subscribe((data) => {
                    this.config = data;
                    HandShakeConfig.publicKey = this.config["checkout_public_key"];
                    resolve(true);
                }, (error: any) => {
                    console.error(error);
                    throw throwError(error);
                });
        });
    }

    get(key: string) {
        return this.config[key];
    }
}

export function ConfigFactory(config: ConfigService) {
    return () => config.load();
}

export function init() {
    return {
        provide: APP_INITIALIZER,
        useFactory: ConfigFactory,
        deps: [ConfigService],
        multi: true
    };
}

const ConfigModule = {
    init: init
}

export { ConfigModule };
